import * as React from "react";
import AppBar from "@mui/material/AppBar";
import Box from "@mui/material/Box";
import Toolbar from "@mui/material/Toolbar";
import IconButton from "@mui/material/IconButton";
import Typography from "@mui/material/Typography";
import MenuIcon from "@mui/icons-material/Menu";
import Container from "@mui/material/Container";
import Stack from "@mui/material/Stack";
import logo from "../../../Assets/Images/logo.svg";
import { useNavigate } from "react-router-dom";
import {
  styles,
  MenuStyle,
  Span,
  NavLink,
  SmNavlink,
  NavButton,
} from "./styles";
import { useDispatch, useSelector } from "react-redux";
import { chooseModalLogin } from "../../../Infrastructure/States/authModalsSlice";
import useAuthentication from "../../../Infrastructure/States/onAuthStateChange";
import AuthModals from "../../Common/AuthModals/authModals";
import { DropdownSmallScreen } from "../../Common/Header/Dropdowns/DropdownSmallScreen/dropdownSmallScreen";
import Dropdown from "../../Common/Header/Dropdowns/DropdownLargeScreen/dropdown";
import paths from "../../../Infrastructure/Router/paths";

const OrganizationNavbar = () => {
  const dispatch = useDispatch();

  const chooseModal = useSelector((state) => state.auth.chooseModal);
  const [anchorElNav, setAnchorElNav] = React.useState(null);

  const { user } = useAuthentication();
  const navigate = useNavigate();

  const handleOpenNavMenu = (event) => {
    setAnchorElNav(event.currentTarget);
  };

  const handleCloseNavMenu = () => {
    setAnchorElNav(null);
  };

  const handleLoginButtonClick = () => {
    dispatch(chooseModalLogin());
    handleCloseNavMenu();
  };

  const handleBookDemoClick = () => {
    navigate(paths.contactPage.path);
    handleCloseNavMenu();
  };

  const navigateToHome = () => {
    navigate(paths.home.path);
  };

  const handleMenuClick = (route) => {
    navigate(route);
    handleCloseNavMenu();
  };

  return (
    <AppBar sx={styles.appBar} position="sticky">
      {<AuthModals chooseModal={chooseModal} />}
      <Container maxWidth="xl">
        <Toolbar disableGutters>
          <Box sx={styles.logo} onClick={navigateToHome}>
            <img src={logo} className=" img-fluid" alt="Vulcan Learning logo" />
          </Box>
          <Span>
            <Typography
              noWrap
              onClick={navigateToHome}
              color="primary"
              sx={styles.logoTypo}
              className="logo-vulcan"
            >
              Vulcan
            </Typography>
          </Span>
          {/* Large Screen */}
          <Box sx={styles.xsMenuBox}>
            <Span onClick={() => navigate(paths.ourMission.path)}>
              <NavLink color="secondary">About</NavLink>
            </Span>
            <Span onClick={() => navigate(paths.contactPage.path)}>
              <NavLink color="secondary">Contact</NavLink>
            </Span>
          </Box>
          {/* Small Devices */}
          <Box sx={styles.xsLogoMainBox}>
            <Box sx={styles.xsLogo} onClick={navigateToHome}>
              <img src={logo} className=" img-fluid" alt="" />
            </Box>
            <Typography
              variant="h5"
              noWrap
              onClick={navigateToHome}
              color="primary"
              sx={styles.xsLogoName}
            >
              Vulcan
            </Typography>
          </Box>

          {/* Small Devices */}
          <Box sx={styles.menuIcon}>
            <IconButton
              size="large"
              aria-label="open navigation menu"
              aria-controls="new-menu-appbar"
              aria-haspopup="true"
              onClick={(e) => handleOpenNavMenu(e)}
              color="inherit"
            >
              <MenuIcon color="primary" fontSize="small" />
            </IconButton>
            <MenuStyle
              id="new-menu-appbar"
              disableScrollLock
              anchorEl={anchorElNav}
              keepMounted
              transformOrigin={{
                vertical: "top",
                horizontal: "left",
              }}
              open={Boolean(anchorElNav)}
              onClose={handleCloseNavMenu}
              sx={styles.menu}
              PaperProps={{
                sx: {
                  borderRadius: "20px !important",
                },
              }}
            >
              <Box
                display="flex"
                flexDirection="column"
                justifyContent="flex-start"
                alignItems="flex-start"
                sx={{ pl: "10px", pr: "10px" }}
              >
                <SmNavlink
                  variant="body2"
                  onClick={() => handleMenuClick(paths.ourMission.path)}
                >
                  About
                </SmNavlink>

                <SmNavlink
                  onClick={() => handleMenuClick(paths.contactPage.path)}
                  variant="body2"
                >
                  Contact
                </SmNavlink>
              </Box>
              <Box
                display="flex"
                justifyContent="space-around"
                gap="10px"
                pt={user ? "0px" : "20px"}
                px="10px"
              >
                {user ? (
                  <DropdownSmallScreen handleCloseNavMenu={handleCloseNavMenu} />
                ) : (
                  <>
                    <NavButton onClick={handleLoginButtonClick}>
                      Login
                    </NavButton>

                    <NavButton onClick={handleBookDemoClick} demo="true">
                      Book a Demo
                    </NavButton>
                  </>
                )}
              </Box>
            </MenuStyle>
          </Box>

          <Box
            display="flex"
            justifyContent="flex-end"
            alignItems="center"
            sx={styles.rightBox}
          >
            <Stack direction="row" spacing={2}>
              {user ? (
                <Dropdown />
              ) : (
                <>
                  <NavButton onClick={handleLoginButtonClick}>
                    Login
                  </NavButton>

                  <NavButton demo="true" onClick={handleBookDemoClick}>
                    Book a Demo
                  </NavButton>
                </>
              )}
            </Stack>
          </Box>
        </Toolbar>
      </Container>
    </AppBar>
  );
};

export default OrganizationNavbar;
